/**
 * Tooltip Initialization Handler
 * Initializes all Bootstrap tooltips on page load and after dynamic content updates
 */

import * as bootstrap from 'bootstrap'

function initTooltips() {
  // Initialize all tooltips with data-bs-toggle="tooltip"
  const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
  const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))
}

// Initialize tooltips when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initTooltips)
} else {
  // DOM is already ready, run immediately
  initTooltips()
}

// Re-initialize tooltips after Turbo navigation (if Turbo is used)
if (window.Turbo) {
  document.addEventListener('turbo:load', initTooltips)
}

